<ng-content select="glxy-confirmation-secondary-actions, [glxyConfirmationSecondaryActions]" />

<ng-content select="glxy-confirmation-primary-actions, [glxyConfirmationPrimaryActions]" />
